// Generate Production Planning 

import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import DynamicDataTable from '../../../components/DynamicDataTadble/DynamicDataTable';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';
import UploadImage from '../../../assets/images/uploadImg.svg';


class GenerateProductionPlanning extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        UserId: null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [],
        approvalRoleId: null,
        UserId1: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        EmailId: '',
        Password: '',
        MobileNumber: '',
        Activedirectory: false,
        Adloginid: '',
        Disablelogin: false,
        IsActive: false,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false,
        fromDate: null,
        toDate: null,
        restaurantId: null,
        restaurantOptions: [],
        Menuitems: [],
        rowSeq: 0,
        branch: '',
        recipeDetails: []



    }

    ItemTemplate = (rowData) => {
        return (
            <Dropdown
                placeholder="Select Item"
                showClear
                options={this.props.MenuItem}
                value={rowData.Item}
                onChange={(e) => this.rowChange(e, rowData, 'Item')}
                optionLabel="label"
                optionValue="value"
                {...DROPDOWN_CONFIG}
            />
        );
    }

    // QuantityTemplate = (rowData) => {
    //     return (
    //         <InputText className="p-col-12" value={rowData.Quantity} placeholder="Quantity" onChange={(e) => this.rowChange(e, rowData, 'Quantity')} />

    //     );
    // }

    QuantityTemplate = (rowData) => {
        return (
            <InputText
                className="p-col-12"
                value={rowData.Quantity}
                placeholder="Quantity"
                onChange={(e) => this.rowChange(e, rowData, 'Quantity')}
            />
        );
    }
    UnitTemplate = (rowData) => {
        return (
            <Dropdown
                placeholder="Select Unit"
                showClear
                options={this.props.Unit}
                value={rowData.Unit}
                onChange={(e) => this.rowChange(e, rowData, 'Unit')}
                optionLabel="label"
                optionValue="value"
                {...DROPDOWN_CONFIG}
            />
        );
    }

    actionTemplate = (rowData) => {
        return (
            <Button icon="pi pi-trash" className="p-button-primary" onClick={() => this.removeRow(rowData)} />
        );
    }

    // Template = (rowData) => {
    //     return (
    //         <InputText className="p-col-12" value={rowData.fromAccount} placeholder="From Account" onChange={(e) => this.rowChange(e, rowData, 'fromAccount')} />
    //     );
    // }
    resolveLabel = (reduxList, value) => {
    const match = reduxList?.find(item => item.value === value);
    return match ? match.label : value;
}

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GeUsers?id=' + id);
        this.props.getMasterKeywordList('Unit');
        this.props.getMasterKeywordList('MenuItem');
        this.props.getMasterKeywordList('Uom');
        this.props.getMasterKeywordList('Ingredient');
        this.props.getMasterKeywordList('branch');
        let type = this.props.match.params.type;

        // axios.get('/master/api/DropDownValues/MenuItem')
        //     .then(response => {
        //         const menuOptions = response.data.map(item => ({
        //             label: item.text,
        //             value: item.id
        //         }));

        //         this.setState({ menuOptions });
        //     });

        // axios.get('/master/api/DropDownValues/Unit')
        //     .then(response => {
        //         const unitOptions = response.data.map(item => ({
        //             label: item.text,
        //             value: item.id
        //         }));

        //         this.setState({ unitOptions });
        //     });

        if (type !== 'add') {
            this.timer();
        }
    }

    timer = () => {
        this.intervalID = setInterval(() => {
            this.fetchSingleProcess();
        }, 2000)
    }
    componentWillUnmount() {
        if (this.props.tableLists.usersList !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () => {

        let id = this.props.match.params.id;
        let type = this.props.match.params.type;
        let storageItems = [];
        if (this.props.tableLists.usersList !== undefined) {
            storageItems = this.props.tableLists.users;
            clearInterval(this.intervalID);
        }
        if (storageItems) {
            let filterData = storageItems;
            if (filterData) {
                let roles = '';
                let functionalRoles = '';
                let approvalroles = '';
                if (filterData.roleAssigned != null) {
                    roles = filterData.roleAssigned.split(",")
                }
                if (filterData.functionalRole != null) {
                    functionalRoles = filterData.functionalRole.split(",")
                }
                if (filterData.approvalrole != null) {
                    approvalroles = filterData.approvalrole.split(",")
                }
                var data = {
                    type: type,
                    Id: filterData.id,
                    UserId: filterData.userId,
                    EmployeeId: filterData.employeeId,
                    RoleId: roles,
                    approvalRoleId: approvalroles,
                    UserId1: filterData.userid1,
                    FirstName: filterData.firstName,
                    functionalRoleId: functionalRoles,
                    MiddleName: filterData.middleName,
                    LastName: filterData.lastName,
                    EmailId: filterData.emailId,
                    Password: filterData.password,
                    MobileNumber: filterData.mobileNumber,
                    Activedirectory: filterData.activedirectory,
                    Adloginid: filterData.adloginid,
                    Disablelogin: filterData.disablelogin,
                    IsActive: filterData.isActive,
                    CreatedBy: filterData.createdby,
                    CreatedDate: filterData.createddate,
                }
                this.setState(data);

            }
        }

    }


    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true })

    }
    calculate = () => {
    if (this.state.Menuitems.length === 0) {
        this.growl.show({ severity: 'error', summary: null, detail: 'Please add at least one menu item' });
        return;
    }

    const requestBody = this.state.Menuitems.map(row => ({
        menuItemId: row.Item,
        qty: parseFloat(row.Quantity)
    }));

    const companyId = this.state.CompanyId;

    axios.post(`/master/api/res/CalculateRecipe?companyId=${companyId}`, requestBody)
        .then(response => {
            const recipeDetails = response.data.map((item, index) => ({
                 rowId: index,
                Item: item.ingredientId,        // matched to ingredientNameTemplate lookup
                Quantity: item.requiredQuantity, // from your sample response
                Unit: item.uomId  // adjust to match your response field
                // Unit: item.unitId           // adjust to match your response field
            }));
            this.setState({ recipeDetails });
            this.growl.show({ severity: 'success', summary: null, detail: 'Recipe calculated successfully' });
        })
        .catch(error => {
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to calculate recipe' });
        });
}

    generate = () => {
        if (!this.state.fromDate) {
            this.growl.show({ severity: 'error', summary: null, detail: 'From Date is required' });
            return;
        }
        if (!this.state.toDate) {
            this.growl.show({ severity: 'error', summary: null, detail: 'To Date is required' });
            return;
        }
        if (!this.state.branch) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Restaurant/Kitchen is required' });
            return;
        }

        const companyId = this.state.CompanyId;
        const fromDate = this.state.fromDate.toISOString();
        const toDate = this.state.toDate.toISOString();
        const outLet = this.state.branch;

        axios.post(`/master/api/res/GetMenuForecast?companyId=${companyId}&FromDate=${fromDate}&ToDate=${toDate}&OutLet=00000000-0000-0000-0000-000000000001`)
            .then(response => {
                const Menuitems = response.data.map((item, index) => ({
                    rowId: index,
                    Item: item.menuItemId,
                    Quantity: item.forecastQuantity,
                    Unit: item.unitId
                }));

                this.setState({ Menuitems, rowSeq: response.data.length });
                this.growl.show({ severity: 'success', summary: null, detail: 'Menu Forecast generated successfully' });
            })
            .catch(error => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate menu forecast' });
            });
    }

    add = () => {

        if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.RoleId === null || this.state.RoleId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
            return;
        }

        else if (this.state.UserId1 === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
            return;
        } else if (this.state.FirstName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
            return;
        } else if (this.state.LastName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
            return;
        } else if (this.state.EmailId === "" || this.state.EmailId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
            return;
        } else if (this.state.Password === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
            return;
        } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
            return;
        } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
            return;
        }
        var data = {
            EmployeeId: this.state.EmployeeId,
            RoleId: null,
            UserId1: this.state.UserId1,
            FirstName: this.state.FirstName,
            FunctionalRole: this.state.functionalRoleId.join(),
            Approvalrole: this.state.approvalRoleId.join(),
            MiddleName: this.state.MiddleName,
            LastName: this.state.LastName,
            EmailId: this.state.EmailId,
            Password: this.state.Password,
            MobileNumber: this.state.MobileNumber,
            RoleAssigned: this.state.RoleId.join(),
            Activedirectory: this.state.Activedirectory,
            Adloginid: this.state.Adloginid,
            Disablelogin: this.state.Disablelogin,
            IsActive: this.state.IsActive,
            CompanyId: this.state.CompanyId,
            CreatedBy: this.state.createdBy,
            CreatedDate: this.state.createdDate,
        }


        if (this.state.type === 'edit') {
            data.UserId = this.state.UserId;
            data.Id = this.state.Id
        }

        this.props.processDynamicData('user', this.state.type, data, 'GeUsers');

    }

    resetData = () => {
        var data = {
            UserId: null,
            EmployeeId: null,
            RoleId: null,
            functionalRoleId: null,
            approvalRoleId: null,
            UserId1: '',
            FirstName: '',
            MiddleName: '',
            LastName: '',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type: 'add',
            rowSeq: 0,
            recipeDetails: []

        }
        this.setState(data);
    }

    updateData = () => {
        // Add your update logic here
        this.growl.show({ severity: 'success', summary: null, detail: 'Production Planning Updated Successfully' });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    rowChange = (e, rowData, field) => {

        const value = e.value !== undefined
            ? e.value
            : e.target.value;

        const Menuitems = this.state.Menuitems.map(row =>
            row.rowId === rowData.rowId
                ? { ...row, [field]: value }
                : row
        );

        this.setState({
            Menuitems,
            touch: true
        });
    }
    addRow = () => {
        let newRow = {
            rowId: this.state.rowSeq,
            Item: '',
            Quantity: '',
            Unit: null
        };

        this.setState({
            Menuitems: [...this.state.Menuitems, newRow],
            rowSeq: this.state.rowSeq + 1,
            touch: true
        });
    }

    removeRow = (rowData) => {
        let excludeIds = [rowData.rowId, ...this.getDescendantIds(rowData.rowId)];
        let Menuitems = this.state.Menuitems.filter(row => !excludeIds.includes(row.rowId));
        this.setState({ Menuitems, touch: true });
    }

    getDescendantIds = (rowId) => {
        let descendants = [];
        let children = this.state.Menuitems.filter(row => row.parent === rowId);
        children.forEach(child => {
            descendants.push(child.rowId);
            descendants = [...descendants, ...this.getDescendantIds(child.rowId)];
        });
        return descendants;
    }

    

    render() {
        console.log(this.props.branch)
        if (this.props.success) {
            REDIRECT_TO_URL('/users/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/users/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }





        const header = () => { }
        // <div style={{ 'textAlign': 'right' }}>
        //     <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
        // </div>


        const tableData = [
            {
                id: "1",
                rawmaterial: "Rice",
                quantity: "10",

            },
            {
                id: "2",
                rawmaterial: "Wheat",
                quantity: "5",

            },
            {
                id: "3",
                rawmaterial: "Pizza Base",
                quantity: "20",
            }
        ];

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    {/* Main Card Container - Merged */}
                    <div className="card card-w-title" style={{ position: 'relative', paddingBottom: '20px' }}>
                        <h1>Generate Production Planning</h1>

                        {/* From Date, To Date, Restaurant/Kitchen Section */}
                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <div className="card card-w-title" style={{ marginBottom: '0' }}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="textarea">From Date</label>
                                            <div className="mt1">
                                                <Calendar className="width100" placeholder="From Date" name="fromDate" value={this.state.fromDate} onChange={this.handleChange} disabled={false} />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="textarea">To Date</label>
                                            <div className="mt1">
                                                <Calendar className="width100" placeholder="To Date" name="toDate" value={this.state.toDate} onChange={this.handleChange} disabled={false} />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Restaurant/Kitchen <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" options={this.props.branch} value={this.state.branch} optionLabel="label" optionValue="value"
                                                    onChange={this.handleChange} placeholder="Select Restaurant/Kitchen" name="branch" {...DROPDOWN_CONFIG} />
                                            </div>
                                        </div>
                                        {/* <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label">Stock Available to store <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" options={this.state.restaurantOptions} value={this.state.restaurantId}
                                                    onChange={this.handleChange} placeholder="Select Store" name="restaurantId" {...DROPDOWN_CONFIG} />
                                            </div>
                                        </div> */}

                                        <div className="p-col-12 p-md-6 p-lg-12">
                                            <Button style={{ float: 'right' }} label="Generate" className="ml1 p-button-secondary" onClick={this.generate} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Enter Items Section - Merged with no space */}
                        <div className="p-grid mt1" style={{ marginTop: '20px' }}>
                            <div className="p-col-12">
                                <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Menu</h3>
                                    <Button label="Add Row" icon="pi pi-plus" className="p-button-success" onClick={this.addRow} style={{ marginLeft: '10px' }} />
                                </div>
                                <div className="p-grid" style={{ marginTop: '20px' }}>
                                    <div className="p-col-12">

                                        <DataTable value={this.state.Menuitems} dataKey="rowId" responsiveLayout="scroll">
                                            <Column field="Item" header="Menu Item" body={this.ItemTemplate} />
                                            <Column field="Quantity" header="Quantity" body={this.QuantityTemplate} />
                                            {/* <Column field="Unit" header="Unit" body={this.UnitTemplate} /> */}

                                            <Column header="Action" body={this.actionTemplate} />
                                        </DataTable>


                                        {/* Buttons Section */}
                                        <div style={{ marginTop: '20px', textAlign: 'right' }}>
                                            <Button label="Reset" className="p-button-secondary" onClick={this.resetData} style={{ marginRight: '10px' }} />
                                            <Button label="Calculate" className="p-button-secondary" onClick={this.calculate} />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ borderBottom: '2px solid #d0d0d0', paddingBottom: '6px', marginBottom: '10px', marginTop: '10px', flex: 1 }}>Ingredients</h3>
                                </div>
                                <DataTable ref={(el) => this.dt = el} value={this.state.recipeDetails} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >


                                    <Column field="Item" header="Ingredient name" body={(row) => this.resolveLabel(this.props.Ingredient, row.Item)}  />
                                    <Column field="Quantity" header="Quantity" />
                                    <Column field="Unit" header="Unit"body={(row) => this.resolveLabel(this.props.Uom, row.Unit)}  />
                                    {/* <Column field="purchasequantity" header="Purchase Quantity" /> */}
                                    <Column body={this.actionTemplate} header="Action" />

                                </DataTable>


                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-lg-12">
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">Issue to store <span className="requiredColor">*</span></label>
                        <div className="mt1">
                            <Dropdown className="p-col-12" options={this.state.restaurantOptions} value={this.state.restaurantId}
                                onChange={this.handleChange} placeholder="Select Issue to store" name="restaurantId" {...DROPDOWN_CONFIG} />
                        </div>
                    </div>
                    <Button style={{ float: 'right' }} label="Issue to store" className="ml1 p-button-secondary" onClick={this.updateData} />
                </div>
            </div >
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Unit: state.keyword.Unit,
        MenuItem: state.keyword.MenuItem,
        tableLists: state.master.tableLists,
        branch: state.keyword.branch,
        Uom : state.keyword.Uom,
        Ingredient : state.keyword.Ingredient,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GenerateProductionPlanning);